import { BlacklineSchema } from '@/api/blackline/blackline';
import { Button } from '@/components/ui/button';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { ArrowUpDown, Eye } from 'lucide-react';

import { DownloadPolicies } from './download';

export const columns: ColumnDef<BlacklineSchema>[] = [
	{
		accessorKey: 'id',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				File Id
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => <div className="font-medium">{row.original.id}</div>,
	},
	{
		accessorKey: 'importDate',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Export Date
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="font-medium">
					{row.original.importDate ? format(row.original.importDate, 'P') : '---'}
				</div>
			);
		},
	},
	{
		accessorKey: 'originalPayload',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				File Type
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => <div className="font-medium">{row.original.originalPayload}</div>,
	},
	{
		accessorKey: 'recordCount',
		header: () => <div >Records In File</div>,
		cell: ({ row }) => <div className="font-medium">{row.original.recordCount}</div>,
	},
	{
		id: 'actions',
		cell: ({ row }) => (
			<div>
				<DownloadPolicies fileData={row.original.fileData} />
			</div>
		),
	},
];
